import type { Dispatch } from 'redux';

import { actionResetProgress } from 'src/app/state/modules/app/progress';

export default () => (dispatch: Dispatch) => {
  dispatch(actionResetProgress());
};
